import type { TastingStatus } from "../types";

export function TastingBadge({
  status,
  deadlineThisYear = false,
  deadlinePassed = false,
}: {
  status: TastingStatus;
  deadlineThisYear?: boolean;
  deadlinePassed?: boolean;
}) {
  let tone = "unknown";
  if (status === "À garder") tone = "keep";
  else if (status === "À boire dès maintenant") tone = "ready";
  let deadlineTone = "";
  if (status === "À boire dès maintenant") {
    if (deadlinePassed) deadlineTone = " tasting-deadline-past";
    else if (deadlineThisYear) deadlineTone = " tasting-deadline-current";
  }

  return (
    <span
      className={`tasting-badge tasting-${tone}${deadlineTone}`}
    >
      {status}
    </span>
  );
}
